import { ClientApi } from '../../../api';
import { AppError } from '../../../api/utils/ErrorHandler';
import { useContainer } from '../../useContainer';

interface ExecDeleteOptions {
    onSuccess?: () => void;
    onError?: (error: AppError | string) => void;
}

const useHttpDeletePaymentTerm = () => {
    const clientApi: ClientApi = useContainer(ClientApi);

    const execDelete = (id: string, options?: ExecDeleteOptions) => {
        const { exec, abort } = clientApi.deleteTerm({
            params: { id },
            onSuccess: () => {
                options?.onSuccess?.();
            },
            onError: error => {
                options?.onError?.(error);
            },
        });

        exec();
        return abort;
    };

    return { execDelete };
};

export default useHttpDeletePaymentTerm;
